var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card-actions",
        { staticClass: "card-bg-2" },
        [
          _c("AddDataTypeDialog", {
            attrs: { mfId: _vm.mfId },
            model: {
              value: _vm.dataSources,
              callback: function ($$v) {
                _vm.dataSources = $$v
              },
              expression: "dataSources",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          "hide-actions": "",
          headers: _vm.headers,
          items: _vm.dataSources,
          "no-data-text": "It's looking empty here. Add some data types!",
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item }) {
              return [
                _c("td", [_vm._v(_vm._s(item.name))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.dataTypeName))]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-divider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }